<template>
	<div class="section-py w-full">
		<div class="container" :class="[containerClass]">
			<slot />
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	containerClass: {
		type: String,
		default: '',
		required: false,
	},
})
</script>
